import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "view";
export var VIEW_CONSTANTS = {
    elementName: elementName
};
